export const previewTokenStorageKey = "partfinder.preview.token";

export const getPreviewToken = () => localStorage.getItem(previewTokenStorageKey);

export const setPreviewToken = (token: string) => {
  localStorage.setItem(previewTokenStorageKey, token);
};

export const clearPreviewToken = () => {
  localStorage.removeItem(previewTokenStorageKey);
};
